import { observable, decorate, action } from 'mobx'

/**
 * Describes the store containing al info about notifier component for displaying toasts and other help messages.
 */
class NotifierStore {
    constructor() {
        /**
         * @Observable
         * @type {object}
         */
        this.showMessage = false
    }

    /**
     * @type {Function & IAction}
     */
    setShowMessage = action(show => {
        this.showMessage = show
    })
}

export default decorate(NotifierStore, {
    showMessage: observable,
})
